import { motion } from 'motion/react';
import { useTranslation } from 'react-i18next';

interface CardItem {
  num: string;
  head: string;
  body: string;
}

export function ResetPasswordPromoPane() {
  const { t } = useTranslation();
  const items = t('auth.reset.promo.cardItems', { returnObjects: true }) as CardItem[];

  return (
    <div
      className="relative flex w-full flex-col items-start overflow-hidden bg-accent p-16 pl-14 text-fg-inv"
      style={{ backgroundImage: 'radial-gradient(circle at 100% 0%, rgba(255,255,255,0.18), transparent 50%)' }}
    >
      <div className="text-[12px] font-semibold uppercase tracking-[0.18em] opacity-70">
        {t('auth.reset.promo.eyebrow')}
      </div>

      <div className="mt-8 max-w-[480px] font-serif text-[56px] font-medium leading-[1.05] tracking-[-0.02em]">
        {t('auth.reset.promo.quotePart1')}
        <br />
        {t('auth.reset.promo.quotePart2')}{' '}
        <em className="font-medium italic">{t('auth.reset.promo.quotePart2Em')}</em>
        {t('auth.reset.promo.quotePart2Tail')}
      </div>

      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.45, delay: 0.18, ease: 'easeOut' }}
        className="mt-12 w-full max-w-[420px] rounded-3xl bg-fg-inv p-6 text-fg"
      >
        <div className="mb-3.5 font-serif text-xl font-medium tracking-[-0.01em]">
          {t('auth.reset.promo.cardTitle')}
        </div>
        {items.map((item, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, x: -10 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.32, delay: 0.32 + i * 0.08, ease: 'easeOut' }}
            className="flex items-start gap-3 border-t border-line py-2.5 text-[14px] leading-[1.55] first:border-0 first:pt-0"
          >
            <div className="inline-flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-lg bg-elev font-mono text-[12px] font-medium tracking-[0.04em] text-accent">
              {item.num}
            </div>
            <div className="flex-1 text-muted">
              <b className="font-medium text-fg">{item.head}</b> {item.body}
            </div>
          </motion.div>
        ))}
      </motion.div>

      <div className="absolute bottom-12 left-14 font-mono text-[12px] font-medium tracking-[0.04em] opacity-60">
        {t('auth.reset.promo.foot')}
      </div>
    </div>
  );
}
